import React, { memo } from 'react';

// import '@style/modules/project/integrationNavigator.scss';
import '../../../../styles/modules/project/integrationNavigator.scss';
import { HubModule } from '@components/hubModule';
// import CommentAnchor from '@components/directUser/CommentAnchor';
import CommentAnchor from 'src/ddvComment/directUser/CommentAnchor';
import { shouldScrollInToView } from '@components/directUser/utils';

// https://api.powerbi.com?workspaceId=50d4a1db-8a38-417c-9940-6d08379dc295&reportId=09af5ce1-1177-4c08-8bfe-0aa88623b84e
const IntegrationHub = (props) => {
  const { id, section, ...rest } = props;
  return <HubModule section={section} id={id} {...rest} />;
};
export default memo(
  CommentAnchor(IntegrationHub, {
    shouldScrollInToView,
    getAnchorIdFromProp(props) {
      return props?.section?.identifier;
    },
  }),
);
